var _excluded = ["action"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useToast as useChakraToast } from '@chakra-ui/react';
import { IconsProvider, useBreakpoint, useIcons } from '../../../theme';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Toast } from './Toast';
import { jsx as _jsx } from "react/jsx-runtime";
export var useToast = () => {
  var toast = useChakraToast();
  var icons = useIcons();
  var {
    isExtraSmallScreen
  } = useBreakpoint();
  var styles = useMultiStyleConfig('Toast', {
    isMobile: isExtraSmallScreen
  });
  return _ref => {
    var {
      action
    } = _ref,
        options = _objectWithoutProperties(_ref, _excluded);

    // display 1 toast at a time by closing the last toast before popping a new one
    toast.closeAll();
    toast(_objectSpread({
      position: 'top',
      containerStyle: styles['container'],
      render: props => {
        var actionProps = action ? {
          actionType: action.type,
          onAction: action.onAction,
          actionText: action.text
        } : {};
        return (
          /*#__PURE__*/
          // Re-wrap the toast with the icons provider since it's not being rendered in the root element.
          // (Chakra does it already with the ThemeProvider)
          _jsx(IconsProvider, {
            icons: icons,
            children: /*#__PURE__*/_jsx(Toast, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), actionProps), options), toast))
          })
        );
      }
    }, options));
  };
};
//# sourceMappingURL=useToast.js.map